import * as PIXI from 'pixi.js';
import { PARTICLE_ASSETS } from './ParticleAssets';
import { PARTICLE_SHAPE_TYPES } from '../../../CreatePageConstants';

const mediaTextureCache = new Map();

function createCachedTexture(imageUrl) {
    if (mediaTextureCache.has(imageUrl)) {
        return mediaTextureCache.get(imageUrl);
    }

    const texture = PIXI.Texture.from(imageUrl);
    mediaTextureCache.set(imageUrl, texture);
    return texture;
}

export function createMediaTexture(shape, mediaData) {
    if (shape === PARTICLE_SHAPE_TYPES.EMOJI || shape === PARTICLE_SHAPE_TYPES.CUSTOM) {
        return createCachedTexture(mediaData);
    }
    return null;
}

export function clearAllTextures() {
    mediaTextureCache.forEach(texture => texture.destroy(true));
    mediaTextureCache.clear();
}

export const getDefaultTextures = () => ({
    circleTexture1: PIXI.Texture.from(PARTICLE_ASSETS.CIRCLE_GLOW),
    circleTexture2: PIXI.Texture.from(PARTICLE_ASSETS.CIRCLE_BASIC),
    heartTexture1: PIXI.Texture.from(PARTICLE_ASSETS.HEART_GLOW),
    heartTexture2: PIXI.Texture.from(PARTICLE_ASSETS.HEART_BASIC),
    starTexture1: PIXI.Texture.from(PARTICLE_ASSETS.STAR_GLOW),
    starTexture2: PIXI.Texture.from(PARTICLE_ASSETS.STAR_BASIC),
    noteTexture1: PIXI.Texture.from(PARTICLE_ASSETS.NOTE_GLOW),
    noteTexture2: PIXI.Texture.from(PARTICLE_ASSETS.NOTE_BASIC),
});
